import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";

import { formatAmount } from "../../utils/formatTime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../constants/api";
import { errorMessage } from "../../utils/errorMessage";
import useAuthAxios from "../../utils/baseAxios";
import ClipLoader from "react-spinners/ClipLoader";
import GetTickers from "../../components/utils/GetTickers";
import { invalidateActivityQueries } from "../../utils/invalidateActivityQueries";
import { useApiAssets } from "../../hooks/useApiAssets";

const PreviewSwap = ({
  setOpenSwap,
  setOpenSwapPreview,
  setOpenSwapSuccess,
  selectedCoinToObj,
  selectedCoinFromObj,
  feeAmount,
  recieveAmount,
  orderID,
  setReceiveAmount,
  setFeeAmount,
  setOrderID,
  amount,
}: any) => {
  const axiosInstance = useAuthAxios();

  const [timeLeft, setTimeLeft] = useState(7); // Countdown state
  const queryClient = useQueryClient();
  const { toApiAsset } = useApiAssets();

  const fromAssetCode = toApiAsset(selectedCoinFromObj?.abbr);
  const toAssetCode = toApiAsset(selectedCoinToObj?.abbr);

  const getQuote = async () => {
    const response = await axiosInstance.get(
      API.getConversionRate(fromAssetCode, toAssetCode, Number(amount))
    );
    return response.data;
  };

  const {
    data: swapQuote,
    error: error1,
    isLoading: isLoadingg,
    refetch,
  } = useQuery({
    queryKey: ["get-swap-quote", fromAssetCode, toAssetCode, amount],
    queryFn: getQuote,
    enabled:
      !!selectedCoinFromObj?.abbr && !!selectedCoinToObj?.abbr && !!amount,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);

  const swapCoin = async (data: any) => {
    const response = await axiosInstance.post(API.executeSwap, data);
    return response.data;
  };
  const completeSwap = useMutation({
    mutationFn: swapCoin,
    onSuccess: (r) => {
      toast.success(r.message);
      invalidateActivityQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: ["userDetails"] });
      setTimeout(() => {
        setOpenSwapPreview(false);
        setOpenSwapSuccess(true);
      }, 2000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 3) {
          // 2 seconds before reaching 1
          refetch(); // Call your refetch here
        }

        if (prev === 1) {
          return 7; // Reset the countdown
        }

        return prev - 1; // Decrement the countdown
      });
    }, 1000); // Run every 1 second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [refetch]);

  useEffect(() => {
    if (swapQuote) {
      setReceiveAmount(swapQuote?.data?.amountReceived);
      setFeeAmount(swapQuote?.data?.exchange_fee?.flat);
    }
  }, [swapQuote]);

  const { data: coinRates } = GetTickers();
  // console.log(swapQuote);
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenSwapPreview(false);
              setOpenSwap(true);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[12px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview Swap
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Swapping from
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              {selectedCoinFromObj?.name} ({selectedCoinFromObj?.abbr})
            </h4>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Coin to receive
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              {selectedCoinToObj?.name} ({selectedCoinToObj?.abbr})
            </h4>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Exchange rate
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              1 {selectedCoinFromObj?.abbr}~{" "}
              {selectedCoinFromObj?.abbr !== "USDT"
                ? formatAmount(coinRates[fromAssetCode])
                : formatAmount(1 / coinRates[toAssetCode])}
              {selectedCoinToObj?.abbr}
            </h4>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Total coin to receive
            </h4>
            <div className=" mt-2 text-[20px] text-[#13181B] dark:text-gray-100 font-sora font-bold">
              {isLoadingg ? (
                <ClipLoader color="#0B84CB" size={15} />
              ) : (
                <h4>
                  {formatAmount(recieveAmount)} {selectedCoinToObj?.abbr}
                </h4>
              )}
            </div>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">Fee</h4>
            <div className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100 font-sora">
              {isLoadingg ? (
                <ClipLoader color="#0B84CB" size={15} />
              ) : (
                <h4>
                  {formatAmount(feeAmount)} {selectedCoinToObj?.abbr}
                </h4>
              )}
            </div>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Transaction refreshes in
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              {timeLeft} seconds
            </h4>
          </div>
        </div>
        <button
          disabled={completeSwap.isPending}
          onClick={() => {
            const data = {
              fromAsset: fromAssetCode,
              toAsset: toAssetCode,
              amount: Number(amount),
              quoteId: swapQuote?.data?.id,
            };
            completeSwap.mutate(data);
          }}
          className="mt-12 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          {completeSwap.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Swap"
          )}
        </button>
      </div>
    </div>
  );
};

export default PreviewSwap;
